<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    width="800px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider
      >{{ $t('WarehouseManagement.form.Basic') }}
      <template #right>
        <BjLogButton
          v-if="isEdit"
          :id="form.id"
          permission="BusinessChannelPhysicalList_Log"
          :title="form.name"
          api="stockApi"
        />
      </template>
    </BjDivider>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('WarehouseManagement.form.name')" prop="name">
          <BjInput v-model="form.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <BjFormItemCode v-model="form.code" :readonly="isEdit" :label="$t('WarehouseManagement.form.code')" prop="code" />
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('WarehouseManagement.form.Contact')" prop="contactName">
          <BjInput v-model="form.contactName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
      <BjFormItemMobile
        v-model="form.contactPhone"
        prop="contactPhone"
        :label="$t('WarehouseManagement.form.phone')"
        clearable
      />
    </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('WarehouseManagement.form.districtName')" prop="districtName">
          <BjInput v-model="form.districtName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('WarehouseManagement.form.Detailed')" prop="detailAddress">
          <BjInput
            v-model="form.detailAddress"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('WarehouseManagement.form.Detailed')"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item :label="$t('WarehouseManagement.form.city')" prop="cityName">
                  <BjInput v-model="form.cityName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$t('WarehouseManagement.form.country')" prop="fullAddress">
                  <BjRegionCascader v-model="regionList" class="full-width" is-array clearable @change="countryData" />
              </el-form-item>
            </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('WarehouseManagement.form.postcode')" prop="postcode">
          <BjInputCode v-model="form.postcode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('WarehouseManagement.form.Description')" prop="description">
          <BjInput v-model="form.description" autosize type="textarea" show-word-limit :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
    </el-row>

    <BjDivider>{{ isEdit ? $t('editText') : $t('addText') }}{{ $t('WarehouseManagement.form.Bin') }}</BjDivider>
    <el-col :span="24">
      <el-form-item :label="$t('WarehouseManagement.form.warehouse')" prop="logicalWarehouseName">
        <BjInput
          v-model="form.logicalWarehouseName"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { channelApi } from '@/api';
import BjRegionCascader from '@/components/BjRegionCascader';
const getDefaultForm = () => {
  return {
    addressCode: null,
    code: null,
    cityCode: null,
    cityName: null,
    contactName: null,
    contactPhone: null,
    detailAddress: null,
    districtName: null,
    id: null,
    latitude: null,
    longitude: null,
    provinceCode: null,
    provinceName: null,
    tenantId: 'default',
    name: null,
    enableFlag: true,
    logicalFlag: true,
    logicalWarehouseName: null,
    countryName: null,
    countryCode: null,
    postcode: null,
  };
};

export default {
  components: {
    BjRegionCascader,
  },
  data() {
    return {
      // 表单参数
      regionList: [],
      isEdit: false,
      form: getDefaultForm(),
    };
  },
  computed: {
    rules() {
      const validateFullAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form.countryCode || !this.form.provinceCode) {
            callback(new Error(this.$t('WarehouseManagement.form.Please')));
          }
          callback();
        });
      };

      return {
        code: [{ required: true, message: this.$t('WarehouseManagement.form.a'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('WarehouseManagement.form.arehouse'), trigger: 'blur' }],
        contactName: [{ required: true, message: this.$t('WarehouseManagement.form.ontact'), trigger: 'blur' }],
        logicalWarehouseName: [{ required: true, message: this.$t('WarehouseManagement.form.logical'), trigger: 'blur' }],
        fullAddress: { required: true, validator: validateFullAddress, trigger: 'change' },
        detailAddress: [{ required: true, message: this.$t('WarehouseManagement.form.detail'), trigger: 'blur' }],
        cityName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        districtName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        postcode: [{ required: true, message: this.$t('WarehouseManagement.form.postcodeText'), trigger: 'blur' }]
      };
    },
  },
  watch: {
    regionList(value) {
      this.form.countryCode = (value || [])[0];
      this.form.provinceCode = (value || [])[1];
    },
  },
  mounted() {},
  methods: {
    countryData(val) {
      this.form.countryName = val[0]?.label;
      this.form.provinceName = val[1]?.label;
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.regionList = [];
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('WarehouseManagement.form.Edit') : this.$t('WarehouseManagement.form.Create'));
      this.form = Object.assign(getDefaultForm(), info || {});
      if (this.isEdit) {
        this.regionList = [
          Number(info.countryCode),
          Number(info.provinceCode),
        ];
      }
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },

    // 修改API
    updateApi(API_DATA) {
      channelApi.updateWarehouse(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('WarehouseManagement.form.Saved'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    // 新增API
    addApi(API_DATA) {
      channelApi.addWarehouse(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('WarehouseManagement.form.Saved'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
